import './config/mobx';
import { initializeSentry } from './services/sentry.service';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

initializeSentry();

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
